export default __webpack_public_path__ + "static/axicube-services--9e68fdb5d62bc00afbc799e8ede7fb06.pdf";